import React, { Fragment } from 'react'
import { Button, Descriptions, Row } from 'antd'
import Status from '../../../elements/Status'
import SupplierModal from '../../../components/Purchasing/Supplier/SupplierModal'

function SupplierDetails(props) {
  const { supplier, onEdit } = props
  return (
    <Fragment>
      <Row style={{ marginTop: 20, marginLeft: 20 }}>
        <Descriptions bordered column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}>
          <Descriptions.Item label="Status">
            <Status value={supplier.status} />
          </Descriptions.Item>
          <Descriptions.Item label="Location">{supplier.location}</Descriptions.Item>
          <Descriptions.Item label="Tax Registration">
            {supplier.taxRegistration || 'N/A'}
          </Descriptions.Item>
        </Descriptions>
      </Row>
      <Row style={{ marginTop: 20, marginLeft: 20 }}>
        <Button onClick={onEdit} type="dashed" icon="user-add">
          Update Vendor
        </Button>
        <SupplierModal {...props} />
      </Row>
    </Fragment>
  )
}

export default SupplierDetails
